import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Protocolo RESET Rápido',
  desc: 'Aplicalo en segundos en situaciones reales',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'Kit Antibloqueo Clínico',
  desc: 'Herramientas para evitar quedarte en blanco',
  price: '$6.000 ARS'
}, {
  num: 3,
  title: 'Checklist de Acción en Guardia',
  desc: 'Sabé exactamente qué hacer paso a paso',
  price: '$9.000 ARS'
}, {
  num: 4,
  title: 'Simulaciones Clínicas Guiadas',
  desc: 'Entrená tu mente antes de situaciones reales',
  price: '$5.000 ARS'
}, {
  num: 5,
  title: 'Sistema de Prioridades Rápidas',
  desc: 'Decidí qué hacer primero sin confundirte',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Plan de Automatización Mental',
  desc: 'Convertí tu respuesta en automática',
  price: '$6.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-39">
      <div className="max-w-xl mx-auto" data-id="element-40">
        <div className="text-center mb-8" data-id="element-41">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-2" data-id="element-42">
            🎁 PERO ESO NO ES TODO... RECIBE TAMBIÉN LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-43">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-44">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-gray-900 border-2 border-yellow-400 rounded-xl p-5 relative overflow-hidden" data-id="element-45">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-46">
                🎁 GRATIS
              </div>

              {/* Bono label */}
              <div className="flex items-center gap-3 mb-2" data-id="element-47">
                <div className="bg-brand-yellow/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-48">
                  <span className="text-lg" data-id="element-49">🎁</span>
                </div>
                <span className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-50">
                  BONO {bonus.num}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-51">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-gray-500 mb-3 leading-relaxed" data-id="element-52">
                {bonus.desc}
              </p>

              {/* Price */}
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-sm text-gray-600 line-through" data-id="element-54">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-gray-900 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-56">
          <p className="text-gray-500 text-sm line-through mb-1" data-id="element-57">
            Valor total: +$41.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-58">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-59">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}